export const updateFormSchema = {
  type: 'VerticalLayout',
  elements: [
    { 
      type: 'Control', 
      scope: '#/properties/CUSIP', 
      label: 'CUSIP',
    },
  ],
}; 